import { queryOrfElements } from "./orf";
import {
	convertToNumber,
	getParentElement,
	getSvgParentElement,
	hideTooltipByElement,
	showTooltipByElement,
} from "./common";

export const ftransOver = (
	event,
	featureId,
	centerBase,
	letterPosition,
	letterCode,
) => {
	const LETTER_POSITION = convertToNumber(letterPosition);
	const parentElement = getParentElement(event);
	const svgParentElement = getSvgParentElement(event);

	// find the ftrans tooltip -- there is only one for the visualization.  If is doesn't exist, create it now.
	let tooltip;
	const tooltipQuery = parentElement.querySelectorAll(
		".sg-ftrans.sg-tooltip",
	)[0];
	// console.log('tooltipQuery', parentElement, tooltipQuery)
	if (tooltipQuery && tooltipQuery.length !== 0) {
		tooltip = tooltipQuery;
	} else {
		const tooltipText =
			'<table class="sg-ftrans sg-tooltip tooltip_table"><tbody><tr><td>text-goes-here</td></tr></tbody></table>';
		const collection = parentElement.querySelectorAll(
			".sg-tooltip-collection",
		)[0];
		//   console.log('collection', collection)
		collection.insertAdjacentHTML("afterend", tooltipText);

		tooltip = parentElement.querySelectorAll(".sg-ftrans.sg-tooltip")[0];
	}

	// console.log('tooltip', tooltip)

	// find the text element
	const t = queryOrfElements(
		parentElement,
		"sg-ftrans sg-text",
		featureId,
		centerBase,
	)[0];
	t.style.fontWeight = "700";

	let protien = "Stop";
	if (letterCode === "A") protien = "Alanine";
	if (letterCode === "B") protien = "Asparagine";
	if (letterCode === "C") protien = "Cysteine";
	if (letterCode === "D") protien = "Aspartic Acid";
	if (letterCode === "E") protien = "Glutamic Acid";

	if (letterCode === "F") protien = "Phenylalanine";
	if (letterCode === "G") protien = "Glycine";
	if (letterCode === "H") protien = "Histidine";
	if (letterCode === "I") protien = "Isoleucine";
	if (letterCode === "J") protien = "Leucine";

	if (letterCode === "K") protien = "Lysine";
	if (letterCode === "L") protien = "Leucine";
	if (letterCode === "M") protien = "Methionine";
	if (letterCode === "N") protien = "Asparagine";
	if (letterCode === "O") protien = "Pyrrolysine";

	if (letterCode === "P") protien = "Proline";
	if (letterCode === "Q") protien = "Glutamine";
	if (letterCode === "R") protien = "Arginine";
	if (letterCode === "S") protien = "Serine";
	if (letterCode === "T") protien = "Threonine";

	if (letterCode === "U") protien = "Selenocysteine";
	if (letterCode === "V") protien = "Valine";
	if (letterCode === "W") protien = "Tryptophan";
	if (letterCode === "X") protien = "Any";
	if (letterCode === "Y") protien = "Tyrosine";
	if (letterCode === "Z") protien = "Glutamine";

	// find the inner html, rip out everything before ORF and fill in with more parameters
	/*       var s = tooltip.children[0].children[0].children[0].innerHTML;
           var pos = s.indexOf("ORF:");
           s = s.substr(pos);
           if (orf_position == -1) {
             s = "Stop<br><br>" + s;
           } else {
             s = protien + " (" + orf_position + ")<br><br>" + s;
           } */

	let text = "";
	if (protien === "Stop" || LETTER_POSITION === 0) {
		text = protien;
	} else {
		text = `${protien} (${letterPosition})`;
	}
	// console.log('tooltip', tooltip)
	tooltip.children[0].children[0].children[0].innerHTML = text;

	showTooltipByElement(
		svgParentElement,
		tooltip,
		//        query_orf_elements( parentElement, "sg-ftrans sg-text", featureId, centerBase )[0],
		[event.target],
		true,
	);
};

export const ftransOut = (event, featureId, centerBase) => {
	const parentElement = getParentElement(event);

	const tooltip = parentElement.querySelectorAll(".sg-ftrans.sg-tooltip")[0];
	// hide everything related to this orf.
	hideTooltipByElement(tooltip);

	const t = queryOrfElements(
		parentElement,
		"sg-ftrans sg-text",
		featureId,
		centerBase,
	)[0];
	t.style.fontWeight = "400";
};

export const ftransClick = () => {};
